<ng-container *transloco="let t; read: 'widgets.taxonomy-picker'">
  <div class="taxonomy-picker__search-wrapper">
    <xi-search-box
      [placeholder]="t('search-for-node')"
      (onCancelClick)="onSearchChanged('')"
      (onChangeOverride)="onSearchChanged($event.detail.searchText)"
    ></xi-search-box>

    @if (searchValue()) {
      <div @searchControlTrigger>
        <xi-icon-button
          icon="single_arrow_left"
          color="CX"
          [disabled]="searchMatches().length < 2"
          (onClick)="searchPrevious()"
        ></xi-icon-button>
      </div>
    }
    @if (searchValue()) {
      <div @searchControlTrigger>
        <xi-icon-button
          icon="single_arrow_right"
          color="CX"
          [disabled]="searchMatches().length < 2"
          (onClick)="searchNext()"
        ></xi-icon-button>
      </div>
    }

    <xi-default-button
      [text]="t('revert')"
      buttonSize="small"
      [disabled]="!canRevert()"
      (onClick)="clearSelection()"
    ></xi-default-button>

    <xi-default-button
      [text]="t('collapse-all')"
      buttonSize="small"
      [disabled]="!canCollapse()"
      (onClick)="collapseAll()"
    ></xi-default-button>
  </div>

  @if (isLoading()) {
    <div class="taxonomy-picker__loading">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }
  @if (!isLoading() && !dataSource.data.length) {
    <div class="taxonomy-picker__empty">
      {{ t('no-taxonomy-nodes-found') }}
    </div>
  }
  @if (!isLoading()) {
    <div class="taxonomy-picker__scroll" #taxonomyTreeScroll>
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node
          *matTreeNodeDef="let node; when: hasChild"
          matTreeNodePadding
          [id]="'t-' + node.htmlId"
          [class.taxonomy-picker__node--search-match]="
            searchMatches()[currentSearchIndex()] === node
          "
        >
          <mat-checkbox
            [checked]="selectedNodes().has(node)"
            (change)="toggleNodeSelection($event, node)"
            [disabled]="!canToggleNodeSelection(node)"
          >
            <mat-icon
              [fontSet]="hasSelectedChild(node) ? 'material-icons-filled' : 'material-icons'"
              [matTooltip]="
                hasSelectedChild(node)
                  ? t('some-descendants-selected')
                  : t('no-descendants-selected')
              "
              class="taxonomy-picker__children-selection-icon"
              >fiber_manual_record</mat-icon
            >{{ node.name }}
          </mat-checkbox>
          <xi-icon-button
            class="taxonomy-picker__select-children"
            icon="plus"
            [hasAnimation]="false"
            [tooltip]="{ text: t('select-all-children') }"
            [disabled]="!canSelectChildren(node)"
            (onClick)="selectAllChildren(node)"
          ></xi-icon-button>
          <xi-icon-button
            class="taxonomy-picker__deselect-children"
            icon="cancel"
            [hasAnimation]="false"
            [tooltip]="{ text: t('deselect-all-children') }"
            [disabled]="!canDeselectChildren(node)"
            (onClick)="deselectAllChildren(node)"
          ></xi-icon-button>
          @if (showDocumentCount()) {
            <span class="taxonomy-picker__document-count">{{ node.count }} </span>
          }
          <xi-icon-button
            [attr.aria-label]="'Toggle ' + node.name"
            color="orca"
            buttonSize="large"
            [hasAnimation]="false"
            [icon]="treeControl.isExpanded(node) ? 'single_arrow_down' : 'single_arrow_right'"
            (onClick)="toggleNodeExpansion(node)"
          >
          </xi-icon-button>
        </mat-tree-node>
        <mat-tree-node
          *matTreeNodeDef="let node"
          matTreeNodePadding
          class="taxonomy-picker__node--leaf"
          [id]="'t-' + node.htmlId"
          [class.taxonomy-picker__node--search-match]="
            searchMatches()[currentSearchIndex()] === node
          "
        >
          <mat-checkbox
            [checked]="selectedNodes().has(node)"
            (change)="toggleNodeSelection($event, node)"
            [disabled]="!canToggleNodeSelection(node)"
          >
            {{ node.name }}
          </mat-checkbox>
          @if (showDocumentCount()) {
            <span class="taxonomy-picker__document-count">{{ node.count }} </span>
          }
        </mat-tree-node>
      </mat-tree>
    </div>
  }
</ng-container>
